// extracted by mini-css-extract-plugin
export default {"CardHeader":"DHqjRJAVRPOhbCVmcjKA","title":"KmF2k_NSM6Ng1E9s7Hov","actionButton":"eceD82wr43fh8w4CrLTj"};